<div class="container">
  <div class="row">
    <div class="van-integrations-description">
      <div class="van-integrations-description-inner">
        <h1>{{ 'DropboxIntegrationTitle' | translate }}</h1>
        <p>{{ 'DropboxIntegrationDesc' | translate }}</p>
        <img src="././assets/images/dropbox.png" alt="{{ 'DropboxIntegrationStart' | translate }}" /><br />
        <a class="abx-button abx-button-main abx-frame-main-footer-button button action" href="./dropbox/login/">{{ 'DropboxIntegrationStart' | translate }}</a>
      </div>
    </div>
  </div>
</div>
